import { render, staticRenderFns } from "./ReportData.vue?vue&type=template&id=552c19c8&scoped=true"
import script from "./ReportData.vue?vue&type=script&lang=js"
export * from "./ReportData.vue?vue&type=script&lang=js"
import style0 from "./ReportData.vue?vue&type=style&index=0&id=552c19c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c19c8",
  null
  
)

export default component.exports